import React from 'react';

import { Button, Box, Typography, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { FlorencePAGES } from '../../../common/components/tfa-auth/constants/pages';
import { CurrentUser } from '../../../common/types/User';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
  user: CurrentUser;
  onConfirm: () => void;
};

const MobileSubscriptionPopup: React.FC<Props> = ({
  open,
  onClose,
  user,
  onConfirm,
}) => {
  const navigate = useNavigate();

  const redirectToSubscriptionScreen = () => {
    navigate(FlorencePAGES.subscriptions);
  };

  const onCloseEvent = (
    event: never,
    reason: 'backdropClick' | 'escapeKeyDown'
  ) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    onClose();
  };

  return (
    <Modal open={open} onClose={onCloseEvent}>
      <Box sx={modalStyle}>
        <div>
          <Typography sx={{ mt: 1, mb: 1 }} fontWeight={600} fontSize={18}>
            You are currently on the Mobile subscription plan.
          </Typography>
          <Typography color='gray'>
            Please upgrade to the Desktop plan to use the GaleAI desktop
            version.
          </Typography>
          <Button
            onClick={onConfirm}
            variant='contained'
            color='error'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>OK, got it</Typography>
          </Button>
          {user.subscriptionStore === 'stripe' && (
            <Button
              onClick={() => redirectToSubscriptionScreen()}
              variant='contained'
              color='secondary'
              disableElevation
              sx={{
                width: '100%',
                height: 48,
                marginTop: '10px',
                borderRadius: '15px',
              }}
            >
              <Typography color='white'>Redirect me</Typography>
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
};

export default MobileSubscriptionPopup;
